import { render } from "./MenuBar.vue?vue&type=template&id=17c1e028&scoped=true"
import script from "./MenuBar.vue?vue&type=script&lang=ts"
export * from "./MenuBar.vue?vue&type=script&lang=ts"

import "./MenuBar.vue?vue&type=style&index=0&id=17c1e028&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-17c1e028"

export default script